import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Grid,
  TextField,
  InputAdornment,
} from "@mui/material";
import CreateIcon from "../Assets/create-icon.svg";
import { useQuery } from "@apollo/client";
import moment from "moment";
//Icons
import SearchIcon from "@mui/icons-material/Search";
//src
import FooterPagination from "../Components/Include/FooterPagination";
import LoadingPage from "../Components/Include/LoadingPage";
import EmptyData from "../Components/Include/EmptyData";
import { AuthContext } from "../Context/AuthContext";
import { GET_STUDENT_PAYMENT_PAGINATOR } from "../Schema/StudentPayment";

import {
  SelectStudent,
  SelectAcademicYear,
  SelectEnrollByStudent,
  SelectGrade,
  SelectProgramm,
  SelectSchool,
} from "../Components/Include/DynamicSelect";

function programName(programFullName) {
  if (programFullName === "General Programme") {
    return "GP";
  } else if (programFullName === "Foreign Language Programme") {
    return "FLP";
  } else if (programFullName === "Khmer Programme") {
    return "KP";
  } else {
    return programFullName;
  }
}

export default function Student() {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [academicVal, setAcademicVal] = useState({ id: "", title: "" });
  const [classVal, setClassVal] = useState({ id: "", title: "" });
  const [studentVal, setStudentVal] = useState({ id: "", title: "" });
  const [schoolVal, setSchoolVal] = useState({ id: "", title: "" });
  // const [programVal, setProgramVal] = useState({ id: "", title: "" });
  const [programmeListVal, setProgrammeListVal] = useState([]);
  const [programmeListId, setProgrammeListId] = useState([]);
  // console.log("programmeListVal===-=-=",programmeListVal)

  // ======================= getpagination ======================
  const { refetch } = useQuery(GET_STUDENT_PAYMENT_PAGINATOR, {
    variables: {
      page: page,
      limit: limit,
      pagination: true,
      academicYearId: academicVal?.id ? academicVal?.id : "",
      classId: classVal?.id ? classVal?.id : "",
      schoolId: schoolVal?.id ? schoolVal?.id : "",
      studentId: studentVal?.id ? studentVal?.id : "",
      programIds: programmeListId ? programmeListId : [],
    },
    onCompleted: ({ getStudentPaymentPagination }) => {
      console.log("getStudentPaymentPagination:::", getStudentPaymentPagination)
      // 
      setTableData(getStudentPaymentPagination?.data);
      setPaginationData(getStudentPaymentPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  useEffect(() => {
    setLoading(true);
    refetch();
  }, [
    academicVal?.id,
    studentVal?.id,
    classVal?.id,
    schoolVal?.id,
    programmeListId?.id,
  ]);

  useEffect(() => {
    if (programmeListVal?.length !== 0) {
      const newProgrammeList = programmeListVal?.map((row) => row?.id);
      setProgrammeListId(newProgrammeList);
    } else {
      setProgrammeListId([]);
    }
  }, [programmeListVal?.length]);

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">សិស្ស</Typography>
        </Stack>
      </Stack>
      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="field-title">សាលា</Typography>
            <SelectSchool
              className="search-field"
              selectedVal={schoolVal}
              setSelectedVal={setSchoolVal}
            />
          </Grid>

          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="field-title">ឆ្នាំសិក្សា</Typography>
            <SelectAcademicYear
              status={true}
              className="search-field"
              selectedVal={academicVal}
              setSelectedVal={setAcademicVal}
            />
          </Grid>

          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="field-title">កម្មវិធី</Typography>
            <SelectProgramm
              className="search-field"
              setSelectedVal={setProgrammeListVal}
              selectedVal={programmeListVal}
            />
          </Grid>

          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="field-title">សិស្ស</Typography>
            <SelectStudent
              className="search-field"
              selectedVal={studentVal}
              setSelectedVal={setStudentVal}
            />
          </Grid>

          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="field-title">ថ្នាក់</Typography>
            <SelectGrade
              className="search-field"
              selectedVal={classVal}
              setSelectedVal={setClassVal}
            />
          </Grid>

        </Grid>
      </Box>
      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell className="header-title-start" width="6%">
                  ល.រ
                </TableCell>
                <TableCell className="header-title" width="13%">
                  ឈ្មោះសិស្ស
                </TableCell>
                <TableCell className="header-title" width="13%">
                  ឈ្មោះឡាតាំង
                </TableCell>
                <TableCell className="header-title" width="13%">
                  ភេទ
                </TableCell>
                <TableCell className="header-title" width="13%">
                  កម្រិតសិក្សា
                </TableCell>
                <TableCell className="header-title" width="13%">
                  ការបង់ថ្លៃ
                </TableCell>
                <TableCell className="header-title" width="13%">
                  ថ្លៃរដ្ឋបាល
                </TableCell>
                <TableCell className="header-title" width="16%">
                  ផ្សេងៗ
                </TableCell>
                {/* <TableCell className="header-title-end"   ></TableCell> */}
              </TableRow>
            </TableHead>

            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={8} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={8} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      // console.log("row::", row);
                      return (
                        <TableRow className="body-row" key={index}>
                          <TableCell className="body-cell-start" height="50px">
                            {index + paginationData?.slNo}
                          </TableCell>
                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.student?.firstName +
                                " " +
                                row?.student?.lastName}
                            </Typography>
                          </TableCell>
                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.student?.englishName}
                              {/* {row?.enrollmentId?.classId?.gradeId?.gradeName} */}
                            </Typography>
                          </TableCell>
                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.student?.gender}
                              {/* {moment(row?.createdAt).format("DD-MM-YYYY")} */}
                            </Typography>
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.enrollments?.map((e, indx) => {
                              return (
                                <Stack direction="row" spacing={1}>
                                  <Typography
                                    className="member-name"
                                    key={indx}
                                  >
                                    {programName(
                                      e?.enrollment?.programId?.programmNameEn
                                    )}{" "}
                                    -
                                  </Typography>
                                  <Typography
                                    className="member-name"
                                    key={indx}
                                  >
                                    {e?.enrollment?.classId?.gradeId
                                      ?.gradeName +
                                      "" +
                                      e?.enrollment?.classId?.className}
                                  </Typography>
                                </Stack>
                              );
                            })}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.enrollments?.map((e, indx) => {
                              return (
                                <Stack key={indx}>
                                  {e?.invoice !== null ? (
                                    <Typography className="paid-invoice">
                                      បានបង់
                                    </Typography>
                                  ) : (
                                    <Typography className="unpaid-invoice">
                                      មិនបានបង់
                                    </Typography>
                                  )}
                                </Stack>
                              );
                            })}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.enrollments?.map((e, indx) => {
                              return (
                                <Stack key={indx}>
                                  {e?.invoice !== null ? (
                                    <Typography className="paid-invoice">
                                      $ {e?.invoice?.additionalFee?.filter((e) => e?.incomeHead?.incomeType === "AdminFee")[0]?.total || 0}
                                    </Typography>
                                  ) : (
                                    <Typography className="unpaid-invoice">
                                      --:--
                                    </Typography>
                                  )}
                                </Stack>
                              );
                            })}
                          </TableCell>
                          <TableCell className="body-cell-end" align="right">
                            {/* <StudentBookAction
                              editData={row}
                              setRefetch={refetch}
                            /> */}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>
      {/* ==================== Pagination  ============================= */}
      <FooterPagination
        totalPages={paginationData?.totalPages}
        totalDocs={paginationData?.totalDocs}
        limit={limit}
        page={page}
        setPage={setPage}
        handleLimit={handleLimit}
        setLoading={setLoading}
      />
    </div>
  );
}
